import React from 'react';
import GeneralDialog from "../generalDialog/generalDialog";
import Typography from '../../commonComponents/Typography';
import HlxButton from '../../commonComponents/button/button';


export interface IDeleteAttachmentDialogProps {
  fileName: string,
	incidentNumber:any,
  isOpen: boolean,
  handleDelete: () => {},
  handleClose: () => {},
  locale: any
}

const DeleteAttachment = ({
	fileName,
	isOpen,
	handleDelete,
	handleClose,
	locale,
	incidentNumber
}: IDeleteAttachmentDialogProps) => {
	const content = (
		<Typography id="lbl-deleteattachmentmodal-content">
			{locale?.content} <b>{fileName}</b> {locale?.subContent} <b>{incidentNumber}</b>?
		</Typography>
	);
	const button = (
		<HlxButton
			label={locale?.buttonName}
			onClick={handleDelete}
			id="btn-deleteattachmentmodal-delete"
		/>
	);

	return (
		<GeneralDialog
			classname="delete-dialog"
			headerBackgroundDefault={false}
			isOpen={isOpen}
			handleClose={handleClose}
			title={locale?.title}
			content={content}
			buttonSubmit={button}
			cancelLabel={locale?.txtCancel}
		/>
	);

}

DeleteAttachment.defaultProps = {
  fileName: "",
  isOpen: true,
  handleDelete: () => {},
  handleClose: () => {},
  locale: {
    title: "Remove Attachment",
    content: "Are you sure you want to remove",
    subContent: "from",
    buttonName: "OK",
		txtCancel: "Cancel"
  },
};

export default DeleteAttachment;
